import React, { useEffect, useState } from "react";
import LoadWizardHeader from "../../../components/loads/LoadWizardHeader";
import LoadWizardStepper from "../../../components/loads/LoadWizardStepper";
import StepOne from "./StepOne";
import StepTow from "./StepTwo";
import StepThree from "./StepThree";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadsResource } from "../../../helpers/configRoutes/backend_helper";
import { reset_load, update_load } from "../../../store/loads/action"; 

const AddUpdLoad = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const load = useSelector((state) => state.Load.load) || {};

    const [step, setStep] = useState(1);
    const [loadingSave, setLoadingSave] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    // Carga inicial: nuevo vs editar
    useEffect(() => {
        const init = async () => {
            if (id) {
                // Modo edición
                const response = await loadsResource("show", {}, id);
                if (response.status && response.load) {
                    dispatch(update_load(response.load));
                } else {
                    navigate("/loads");
                    return;
                }
            } else {
                // Modo nuevo
                dispatch(reset_load());
            }
            setInitialLoading(false);
        };

        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // Status de pasos (derivado de load)
    const stepsStatus = {
        one: !!(
            load?.charges &&
            load?.client_id &&
            load?.status_id &&
            load?.schedule_id &&
            load?.operator_id &&
            load?.truck_id &&
            load?.trailer_id
        ),
        two: Array.isArray(load?.stops) && load.stops.length > 0,
        three: Array.isArray(load?.evidences) && load.evidences.length > 0,
    };

    // Ajustar el step según qué esté completo (cuando ya tenemos datos)
    useEffect(() => {
        if (initialLoading) return;

        if (!stepsStatus.one) {
            setStep(1);
        } else if (!stepsStatus.two) {
            setStep(2);
        } else if (!stepsStatus.three) {
            setStep(3);
        } else {
            setStep(3); // todo completo, lo dejamos en el último
        }
    }, [initialLoading, stepsStatus.one, stepsStatus.two, stepsStatus.three]);

    const steps = [
        {
            id: 1,
            label: "Load & equipment",
            desc: "Charges, client, truck, trailer and basic info.",
            isCompleted: stepsStatus.one,
        },
        {
            id: 2,
            label: "Stops & route",
            desc: "Pickup, delivery and intermediate stops.",
            isCompleted: stepsStatus.two,
            isBloked: !stepsStatus.one,
        },
        {
            id: 3,
            label: "Documents & evidence",
            desc: "Upload POD, rate confirmations and notes.",
            isCompleted: stepsStatus.three,
            isBloked: !stepsStatus.two,
        },
    ];

    const goNext = () =>
        setStep((prev) => (prev < steps.length ? prev + 1 : prev));
    const goBack = () =>
        setStep((prev) => (prev > 1 ? prev - 1 : prev));
    const isLastStep = step === steps.length;

    const onCancel = () => {
        navigate("/loads");
    };

    const onSave = async () => {
        setLoadingSave(true);

        const response = await loadsResource(
            load.id ? "put" : "post",
            load,
            load.id
        );

        if (response.status) {
            dispatch(reset_load());
            navigate("/loads");
        } else {
            // aquí puedes meter un Toast de error si quieres
        }

        setLoadingSave(false);
    };

    const handleSetStep = (targetStep) => {
        // Bloqueo de navegación directa a pasos posteriores
        if (targetStep === 2 && !stepsStatus.one) return;
        if (targetStep === 3 && !stepsStatus.two) return;
        setStep(targetStep);
    };

    // Mientras carga el load al recargar / editar
    if (initialLoading) {
        return (
            <div className="min-h-screen bg-cs-surface flex items-center justify-center">
                <div className="flex flex-col items-center gap-2 text-sm text-cs-muted">
                    <span className="material-symbols-outlined animate-spin text-xl">
                        progress_activity
                    </span>
                    <span>Loading load data…</span>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-cs-surface">
            <div className="px-2 md:px-3 py-3 max-w-auto mx-auto">
                {/* Header */}
                <LoadWizardHeader step={step} totalSteps={steps.length} />

                {/* Stepper */}
                <LoadWizardStepper
                    steps={steps}
                    step={step}
                    setStep={handleSetStep}
                />

                {/* Contenido del paso */}
                <div className="bg-cs-bg border border-cs-border rounded-2xl shadow-sm px-4 md:px-6 py-5 md:py-6">
                    {step === 1 && (
                        <StepOne
                            step={step}
                            totalSteps={steps.length}
                            onBack={goBack}
                            onNext={goNext}
                            onCancel={onCancel}
                            isLastStep={isLastStep}
                        />
                    )}

                    {step === 2 && (
                        <StepTow
                            step={step}
                            totalSteps={steps.length}
                            onBack={goBack}
                            onNext={goNext}
                            onCancel={onCancel}
                            isLastStep={isLastStep}
                        />
                    )}

                    {step === 3 && (
                        <StepThree
                            step={step}
                            totalSteps={steps.length}
                            onBack={goBack}
                            onNext={goNext}
                            onSave={onSave}
                            onCancel={onCancel}
                            isLastStep={isLastStep}
                            loading={loadingSave}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AddUpdLoad;
